import { Flex, Text } from '@chakra-ui/react'
import { LuTrendingUp as TrendUp, LuTrendingDown as TrendDown } from 'react-icons/lu'

interface TrendIndicatorProps {
  value: number
  direction: 'up' | 'down'
  /** For metrics where 'down' is good (e.g. transit time, incidents) */
  invertColor?: boolean
}

export default function TrendIndicator({ value, direction, invertColor }: TrendIndicatorProps) {
  const isPositive = invertColor ? direction === 'down' : direction === 'up'
  const color = isPositive ? '#2a8a87' : '#c8442f'
  const Icon = direction === 'up' ? TrendUp : TrendDown

  return (
    <Flex alignItems="center" gap={1}>
      <Icon size={14} color={color} />
      <Text fontSize="xs" fontWeight="600" color={color}>
        {value.toFixed(1)}%
      </Text>
    </Flex>
  )
}
